export default "__VITE_ASSET__5e2321a8__"